import _ from 'lodash';
import apiFetch from '@scale/frontend-lib/api-fetch';
import { SubscriptionStatsResponse } from '@scale/shared/studio';
import { FetchGroupsAndLabelersResponse } from '@scale/shared/types/studio/studioTypes';
import { RequestSuccessWithMessage } from '@scale/shared/types/endpoints/customer/selfserve/index';
import {
  ResetBatchPriorityParams,
  SetBatchPriorityParams,
  HasBatchResponse,
  FetchPendingStudioBatchesResponse,
  FetchBatchStatusResponse,
  FetchBatchTaskStateDescriptionsResponse,
  FetchBatchMetricsResponse,
  FetchAuditStatusResponse,
  FetchBatchWorkflowStatsResponse,
} from '@scale/shared/types/endpoints/customer/studio/batch';
import {
  FetchTaskAttemptsResponse,
  SubtaskReadOnlyResponse,
  RedoTaskParams,
  FetchElasticOptionsParams,
  FetchElasticOptionsResponse,
} from '@scale/shared/types/endpoints/customer/studio/task';
import {
  BatchRequestParams,
  TasksRequestParams,
  ProjectRequestParams,
  SubtaskRequestParams,
} from '@scale/shared/types/endpoints/customer/studio/index';

export async function logSyncDataUpload(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/analytics/record_data_upload`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function acceptInviteExisting(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/team/acceptInvite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function resetBatchPriorities(
  params: ResetBatchPriorityParams,
): Promise<RequestSuccessWithMessage> {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/reset_batch_priorities`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function sendAllBackToQueue(
  params: BatchRequestParams,
): Promise<RequestSuccessWithMessage> {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/send_all_back_to_queue`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function setBatchPriorities(
  params: SetBatchPriorityParams,
): Promise<RequestSuccessWithMessage> {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/set_batch_priorities`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function redoAllFromScratch(
  params: BatchRequestParams,
): Promise<RequestSuccessWithMessage> {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/redo_all_from_scratch`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function redoAllFromAnnotation(
  params: BatchRequestParams,
): Promise<RequestSuccessWithMessage> {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/redo_all_from_annotation`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function redoTask(params: RedoTaskParams): Promise<RequestSuccessWithMessage> {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/tasks/redo_task`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function duplicateProject(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/projects/duplicate_project`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function trackStudioPageVisit(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/track_studio_page_visit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function setAssignRejections(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/configs/set_assign_rejections`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function setOcrSettings(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/configs/set_ocr_settings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function addPrelabelModel(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/models/add_prelabel_model`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function updateModelMapping(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/models/update_model_mapping`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function sendBatchesToModel(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/models/send_batches_to_model`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function validatePrelabelingUploadedAsset(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/models/validate_prelabeling_uploaded_asset`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function autoAnnotate(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/tasks/auto_annotate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function removeLabelerFromGroup(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/groups/remove_labeler_from_group`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function updateLabelShortcutMapping(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/preference/label_shortcut/mapping`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function updateProjectMetricsPreference(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `/internal/self_serve/metrics_display/preference`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

// gets

export async function fetchSubscriptionStats(params: $FIXME): Promise<SubscriptionStatsResponse> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/subscription/stats`, {
    query,
  });
}

export async function fetchDeprecatedStudioBundles(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/subscription/deprecated_studio_bundles`, {
    query,
  });
}

export async function fetchHasBatch(params: {}): Promise<HasBatchResponse> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/has_batch`, {
    query,
  });
}

export async function fetchPendingStudioBatches(params: {}): Promise<FetchPendingStudioBatchesResponse> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/fetch_pending_studio_batches`, {
    query,
  });
}

export async function fetchCommonAnswers(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/benchmarks/answers`, {
    query,
  });
}

export async function fetchBenchmarkAndAttempt(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/benchmarks/benchmark_and_attempt`, {
    query,
  });
}

export async function fetchModelsForProject(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/models/fetch_models_for_project`, {
    query,
  });
}

export async function fetchBaseModelsForCustomer(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/models/fetch_base_models_for_customer`, {
    query,
  });
}

export async function fetchModelById(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/models/fetch_model_by_id`, {
    query,
  });
}

export async function fetchGroupsAndLabelers(
  params: $FIXME,
): Promise<FetchGroupsAndLabelersResponse> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/groups/fetch_groups_and_labelers`, { query });
}

export async function fetchTrainingTaskPassThreshold(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/benchmarks/get_training_task_pass_rate`, {
    query,
  });
}

export async function fetchBatchStatus(
  params: BatchRequestParams,
): Promise<FetchBatchStatusResponse> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/fetch_batch_status`, {
    query,
  });
}

export async function fetchBatchWorkflowStats(
  params: BatchRequestParams,
): Promise<FetchBatchWorkflowStatsResponse> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/fetch_batch_workflow_stats`, {
    query,
  });
}

export async function fetchBatchTaskStateDescriptions(
  params: BatchRequestParams,
): Promise<FetchBatchTaskStateDescriptionsResponse> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/fetch_batch_task_state_descriptions`, {
    query,
  });
}

export async function fetchProjectPipelineParams(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/projects/pipeline_params`, {
    query,
  });
}

export async function previewChangeNumReviews(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/projects/change_num_reviews_preview`, {
    query,
  });
}

export async function updateChangeNumReviews(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/projects/change_num_reviews_update`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function fetchTaskStateDescription(
  params: TasksRequestParams & ProjectRequestParams,
): Promise<FetchBatchTaskStateDescriptionsResponse> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/fetch_task_state_description`, {
    query,
  });
}

export async function fetchAllTaskAttempts(
  params: TasksRequestParams & ProjectRequestParams,
): Promise<FetchTaskAttemptsResponse> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/tasks/task_attempts`, {
    query,
  });
}

export async function fetchSubtaskAssignmentReadOnly(
  params: SubtaskRequestParams,
): Promise<SubtaskReadOnlyResponse> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/tasks/subtask_read_only`, {
    query,
  });
}

export async function fetchBatchMetrics(
  params: BatchRequestParams,
): Promise<FetchBatchMetricsResponse> {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/fetch_batch_metrics`, {
    query,
  });
}

export async function fetchAuditStatus(
  params: TasksRequestParams,
): Promise<FetchAuditStatusResponse> {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/batches/fetch_audit_status`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function fetchLabelShortcutMappingInfo(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/preference/label_shortcut/mapping_info`, {
    query,
  });
}

export async function getOrCreateProjectMetricsPreference(params: $FIXME) {
  const query = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/self_serve/metrics_display/preference`, {
    method: 'GET',
    query,
  });
}

export async function fetchMigrationCount(params: $FIXME) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/migration/fetch_migration_count`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function fetchElasticOptions(
  params: FetchElasticOptionsParams,
): Promise<FetchElasticOptionsResponse> {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch(null, `internal/studio/tasks/fetch_elastic_options`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}
